import {contextify} from 'common/util/react';

import {HistoryManager} from '../history-manager';

const context = contextify<HistoryManager>();

export const HistoryManagerProvider = context.Provider;
export const HistoryManagerConsumer = context.Consumer;
export const useHistoryManager = context.hook;
